// extracted by mini-css-extract-plugin
export default {"content":"layout_content__oIHyp","icon":"layout_icon__6YwzC","twitter":"layout_twitter__1GBo8","linkedin":"layout_linkedin__k1NiL","youtube":"layout_youtube__faDhM"};